import { LodashExtractor, StoreNestedFilterExtractor } from '@ddt-web/data-service';

import { FactMappingInterface } from '../../../../models/fact-mapping.interface';
import { FactExtractor } from '../../fact-extractor';

export const STOCK_FACTS: { [factName: string]: FactMappingInterface } = {
	numberOfStocks: {
		extractor: new FactExtractor([new LodashExtractor('positionDetails.children')], children => {
			return children.filter(child => child.assetType === 'ASSET_TYPE_STOCK').length;
		})
	},
	stockPercentage: {
		extractor: new FactExtractor([
			new StoreNestedFilterExtractor(
				['details'],
				'details.portfolioBreakdowns',
				[
					{ propertyToCompare: 'name', comparedValue: 'bpasType', desiredValueExpression: 'sectors' }
				]
			)
		], sectors => {
			return (sectors.find(child => child.name === 'Single Stock')?.contribution || 0) * 100;
		})
	}
};
